import { ResourceBoardFeatureConfigSchema, type ResourceBoardFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `resourceBoard` (SCH-3172): the tile columns on the mobile resource
 * board, and its optional search field (SCH-3231). The tile order is not here; it lives on the stored catalog
 * (`lib/api/resource-board-catalog.ts`).
 *
 * absentIsEmpty: the block is new, so no row carries it until a school saves
 * a column count, and an absent block is today's one-column board.
 *
 * Fallback: one column and no search, the app's reading of an absent
 * `columns` and `searchEnabled` (`ResourceBoardFeatureConfigSchema`: "absent
 * ⇒ 1", "absent ⇒ off"). `enabled` and
 * `visibleForRoles` are required by the base schema and inert for this key;
 * `[]` matches the server's backfill for a feature with no canonical default
 * (`getDefaultVisibleForRoles`, `apps/backend/src/services/config/global-feature-defaults.ts`).
 *
 * Sparse: a save sends only the changed `columns` / `searchEnabled`, merged into the school's row on the
 * server (`resourceBoard` is on `PARTIAL_WRITE_ALLOWED_FEATURES`; it has no
 * write-time invariant).
 */
export const resourceBoard: ScreenFeatureEntry<'global', 'resourceBoard', ResourceBoardFeatureConfig> = {
  resource: 'global',
  wireName: 'resourceBoard',
  schema: ResourceBoardFeatureConfigSchema,
  writeMode: 'sparse',
  absentIsEmpty: true,
  fallback: {
    enabled: false,
    visibleForRoles: [],
    columns: 1,
    searchEnabled: false
  }
}
